<div class="tags-container" data-test-id="applied-tag-list">
  @for (tag of tags(); track tag.id) {
    <div
      class="tag {{ tag.color }}"
      [class.clickable]="clickable()"
      [class.no-color]="!tag.color"
      [class.dark]="tag.color"
      [class.light]="lightBackground()"
      (click)="clicked.emit({ tag, event: $event })"
      [appTooltip]="canEditTag() ? 'Edit tag' : undefined"
    >
      <app-svg src="/assets/icons/tag-filled.svg" size="-1" class="tag-icon"></app-svg>
      <div>{{ tag.name }}</div>
      <button
        appButton
        name="remove"
        location="asset-tags"
        [iconButton]="true"
        shape="round"
        [color]="tag.color ? 'hard-simple' : 'simple-gray-50'"
        height="-2"
        appTooltip="Remove tag"
        (click)="remove.emit({ tag, event: $event })"
      >
        <app-svg src="/assets/icons/cross.svg"></app-svg>
      </button>
    </div>
  }
  <ng-content></ng-content>
</div>
